import $ from 'jquery';
import init from '../../init';

export default function shopFormDirective(context=document.body) {
    const $context = $(context);
    const siteUrl = $('.header_logo > a').attr('href');
    const $forms = $context.find('[sw-shop-form]');
    const $cart = $('.cart');
    const $cartBody = $cart.find('.cart_body');
    const $cartButton = $('.header_cart-button');
    const $cartCount = $cartButton.find('.header_cart-button_count');
    const cartToggler = $cart.data('toggler');

    $forms.on('submit', function(e) {
        e.preventDefault();

        const $this = $(this);
        const data = $this.serialize();

        $.post('', data, function(r) {
            if (r.cart) {

                // Update the quantity as seen on the cart button.
                $cartCount.html(`(${r.cart.totalQty})`);

                // Update the cart body.
                $.get(`${siteUrl}ajax/cart`, '', function(c) {
                    $cartBody.html(c);
                    init($cartBody[0]);

                    // Open the cart, if it isn't already.
                    if (!cartToggler.isOpen) {
                        cartToggler.open();
                    }
                });
            } else {
                console.log(`Form submission failure. Query: ${data}`);
            }
        }, 'json');
    })
}



// WEBPACK FOOTER //
// ./source/scripts/directives/commerce/shop-form.js